module.exports = __webpack_public_path__ + "static/media/gift-points-icon.c3ab9731.svg";